
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import "./styles/dropdown.scss";

const useStyles = makeStyles(theme => ({
    selectEmpty: {
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        marginTop: theme.spacing(2),
        background: '#fff'
    },
}));

export default function DropDown(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(2);
    const handleChange = event => {
        setValue(event.target.value);
        props.setLocation(event.target.value);
    };
    const getDropdown = () => (
        <Select labelId="label" placeholder={props.label} value={props.value ? props.value : props.selectedId} className={`card-dropdown ${classes.selectEmpty}`} onChange={props.view === "Nav" ? handleChange : props.onChange} displayEmpty>
            {
                props.Data.map((obj, index) => {
                    return (
                        <MenuItem className="option" value={obj.value} key={index}>
                            <div className="building">{obj.label}</div>
                            {/* <div className="address">{obj.display.address}</div> */}
                        </MenuItem>
                    )
                })
            }
        </Select>
    );
    return (
        <>
            {
                props.label ?
                    <FormControl className={`${classes.formControl} ${props.className} ${props.mainDropdown ? 'main-dropdown-2' : 'main-dropdown'}`}>
                        <InputLabel shrink id="label">{props.label}</InputLabel>
                        {getDropdown()}
                    </FormControl> :
                    getDropdown()
            }
        </>
    );
}